import instance from '@apis/instance';
import { ItemCategoriesResponse } from '@models/item/itemCategory';

class ItemCategoryApi {
  static getItemCategories(shopId: string): Promise<ItemCategoriesResponse> {
    return instance.get(`/shop/${shopId}/categories`);
  }
}

export default ItemCategoryApi;
